import React from "react";

const GameIcon = ({
 icon_url,
 width,
 cssClassList,
 id
}) => {

  return (
    icon_url &&
      <img src={icon_url} key={icon_url} alt="" className={cssClassList ? cssClassList : "ml-1"} style={{width: width}} id={id}/>
  );
};

export default GameIcon;